<template>
  <div v-loading="loading">
    <div class="pay-wrap">
      <div class="body-content">
        <div class="content-wrapper">
          <div class="main-content">
            <div class="title">
              <div class="main-title">
                守兔影票
              </div>
              <div class="step-bar">
                <el-steps :active="active" finish-status="success" :align-center="alignCenter">
                  <el-step title="提交资料"></el-step>
                  <el-step title="确认订单"></el-step>
                  <el-step title="支付订单"></el-step>
                  <el-step title="完成"></el-step>
                </el-steps>
              </div>
            </div>
            <div class="tip-box">
              <template v-if="payStatus == 0">
                <div class="tip-icon el-icon-warning-outline"></div>
                <div class="main-tip-box">
                  <div class="tip-title">
                    订单提交失败，订单编号：{{orderId}}
                  </div>
                  <div class="tip-sub-title">
                    {{message}}
                  </div>
                </div>
              </template>
              <template v-if="payStatus == 1">
                <div class="tip-icon-success el-icon-circle-check"></div>
                <div class="main-tip-box">
                  <div class="tip-title">
                    订单提交成功，请尽快付款！订单编号：{{orderId}}
                  </div>
                  <div class="tip-sub-title">
                    请您在<span class="pink-class">15分钟内</span>支付完成，否则订单会被自动取消。剩余时间：<span class="pink-class">{{minute}}</span>分 <span class="pink-class">{{second}}</span> 秒
                  </div>
                </div>
              </template>
            </div>
            <div class="pay-money">
              <div class="pay-money-tip">实付金额:</div>
              <div class="pay-money-text" v-if="payStatus == 1"><span class="pay-icon">￥</span>{{money}}</div>
              <div class="pay-money-text" style="font-size: 16px" v-else>加载中...</div>
            </div>
            <div class="pay-way">
              <!--                            <div class="pay-way-tip">支付方式</div>-->
              <!--                            <div class="pay-qrcode-img">-->
              <!--                              <img class="bg-img" src="@/assets/img/promotion/pay_bg.png">-->
              <!--                              <div class="qrcode-img">-->
              <!--                                <div id="qrcode" ref="qrcode"></div>-->
              <!--                              </div>-->
              <!--                            </div>-->
              <div class="pay">
                <div class="pay-item" :class="isPayType == 1?'pay-item-active':''" @click="selectPay(1)">
                  <img src="https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png" alt="">
                  <div class="pay-item-text">支付宝</div>
                </div>
                <div class="pay-item" :class="isPayType == 2?'pay-item-active':''" @click="selectPay(2)">
                  <img src="https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png" alt="">
                  <div class="pay-item-text">微信支付</div>
                </div>
                <div class="pay-item" :class="isPayType == 3?'pay-item-active':''" @click="selectPay(3)" v-if="false">
                  <img src="https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png" alt="">
                  <div class="pay-item-text">银联支付</div>
                </div>
              </div>
            </div>
            <div class="pay-qrcode">
              <div class="qrcode-top">
                <img v-if="isPayImg" :src="isPayImg" alt="">
                <div class="qrcode-top-text">{{isPayTitle}}</div>
              </div>
              <div class="qrcode-center" :style="'background:' + isPayBgColor">
                <div class="qrcode-center-img" v-loading="loadingPay">
                  <img :src="base64" alt="" v-if="base64 && isPayType == 3">
                  <div id="qrcode" ref="qrcode" v-if="isPayType != 3"></div>
                </div>
                <div class="qrcode-center-text">{{isPayText}}</div>
              </div>
            </div>
            <!--                        <div class="pay-btn-wrap">-->
            <!--                            <div class="pay-info-wrap">-->
            <!--                                <div class="pay-money-text">实付金额：</div>-->
            <!--                                <div class="pay-money" v-if="payStatus == 1"><span class="pay-icon">￥</span>{{money}}</div>-->
            <!--                                <div class="pay-money" v-else>提交失败暂无金额</div>-->
            <!--                            </div>-->
            <!--                            <div class="pay-btn" @click="goAlipay">-->
            <!--                               <span>去支付</span>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mini from "@/api/mini";
import SildeNav from '@/components/official/SildeNav.vue'
import DistSildeNav from '@/components/official/DistSildeNav.vue'
import Nav from '@/components/Nav.vue'
import OfficialNav from '@/components/OfficialNav.vue'
import pay from '@/javaApi/pay.js'
import QRCode from 'qrcodejs2';
const payModel = new pay()
const miniModel = new mini()
import {getUserUUID, getNickname, getSnaphotId, setSnapshotId, getPlatformUuid, setHasPackage} from '@/utils/auth'
export default {
  name: "PayList",
  components:{
    SildeNav,
    DistSildeNav,
    Nav,
    OfficialNav
  },
  data(){
    return {
      isEnter: true,
      isBasic: true,
      active: 2,
      alignCenter:true,
      payStatus:2,
      money:0.01,
      message:'',
      orderId:'暂无订单编号',
      packageRecordId:'',
      interval:{},
      minute:0,
      second:0,
      loading:false,
      payMethod: 1, //1-支付宝，2-微信支付
      isPayType:0, // 支付方式1支付宝2微信3银联
      isPayTitle:'', //标题
      isPayText:'', // 提示
      isPayImg:'', // 图片
      isPayBgColor:'', // 背景色
      base64:'',
      isQrcode:false, // 是否已经生成支付二维码
      totalCount:'', //支付倒计时
      timer:'',
      payType: '',
      loadingPay: false
    }
  },
  created(){
    this.loadingPay = true
    console.log(this.$route.query,'this.$route.query==')
    let param = this.copy(this.$route.query)
    param.channelType = 4
    console.log(param,'paramparam==')
    let condition = ( param.platformUuid == '' || param.platformUuid == 0);
    if(condition){
      delete param.platformUuid
    }
    console.log(param.type)
    switch (parseInt(param.type)) {
      case 1:
        this.updatePackage(param)
        // 补差升级
        break;
      case 2:
        // 立刻开通
        this.payForPackage(param)
        break;
      case 3:
        // 立刻续费
        this.conitinuePackage(param)
        break;
      case 4:
        //分销套餐开通
        this.goPayProfit(param)
        break;
    }
  },
  mounted() {
  },
  destroyed() {
    console.log("debug:________________清除定时器______________");
    clearInterval(this.timer);
  },
  methods:{
    goAlipay:function () {
      if(this.payStatus == 0) {
        this.$Message.error('提交订单失败！')
        return
      }
      let param = this.copy(this.$route.query)
      let type = param.type
      let isProfit = Boolean(parseInt(param.isProfit))
      let condition = ((type == 2 && isProfit))
      this.$router.push({
        path: "/pc/pay/alipay",
        query: {
          money:this.money,
          recordId:this.packageRecordId,
          type:condition?0:(isProfit)?1:0
        }
      })
    },
    // 差价升级 套餐
    updatePackage(param){
      param.isProfit = (param.isProfit == 1)
      console.log('param',param)
      miniModel.updatePackage(param).then(response=>{
        this.loading =false
        let res = response.data
        if(res.code == 200){
          if(res.data){
            this.payStatus = 1
            this.orderId = res.data.orderNumber
            console.log('orderId',this.orderId)
            this.packageRecordId = res.data.id
            this.money = res.data.orderPrice
            this.selectPay(1)
            this.initInterval()
            // this.getAliPayHtml()
          }else{
            this.message = res.message?res.message:'系统异常！请稍后再试'
            this.$Message.error(this.message)
            this.payStatus = 0
          }
        }else{
          this.message = res.message?res.message:'系统异常！请稍后再试'
          this.$Message.error(this.message)
          this.payStatus = 0
        }
      }).catch(error=>{
        this.loading =false
        if(error != 'token invalid'){
          this.$Message.error('系统异常！请稍后再试')
        }
        this.payStatus = 0
        this.message = '系统异常！请稍后再试'
      })
    },
    // 开通套餐
    payForPackage(param){
      param.openUserUuid = getUserUUID()?getUserUUID():''
      param.openUserName = getNickname()?getNickname():''
      delete param.type
      param.isProfit = (param.isProfit == 1)
      payModel.payForPackage(param).then(response=>{
        this.loading =false
        let res = response.data
        if(res.code == 200){
          if(res.data){
            this.payStatus = 1
            this.orderId = res.data.payNo
            this.packageRecordId = res.data.packageRecordId
            this.money = res.data.payMoney
            this.$store.dispatch('official/changePackageRecordId', res.data.packageRecordId)
            this.selectPay(1)
            this.initInterval()
            // this.getAliPayHtml()
          }else{
            this.message = res.message?res.message:'系统异常！请稍后再试'
            this.$Message.error(this.message)
            this.payStatus = 0
          }
        }else{
          this.message = res.message?res.message:'系统异常！请稍后再试'
          this.$Message.error(this.message)
          this.payStatus = 0
        }
      }).catch(error=>{
        this.loading = false
        if(error != 'token invalid'){
          this.$Message.error('系统异常！请稍后再试')
        }
        this.payStatus = 0
        this.message = '系统异常！请稍后再试'
      })
    },
    // 续费套餐
    conitinuePackage(param){
      delete param.type
      miniModel.continuePackage(param).then(response=>{
        this.loading =false
        let res = response.data
        if(res.code == 200){
          if(res.data){
            this.payStatus = 1
            this.orderId = res.data.orderNumber
            console.log('orderId',this.orderId)
            this.packageRecordId = res.data.id
            this.money = res.data.orderPrice
            this.$store.dispatch('official/changePackageRecordId', res.data.packageRecordId)
            this.selectPay(1)
            this.initInterval()
            // this.getAliPayHtml()
          }else{
            this.message = res.message?res.message:'系统异常！请稍后再试'
            this.$Message.error(this.message)
            this.payStatus = 0
          }
        }else{
          this.message = res.message?res.message:'系统异常！请稍后再试'
          this.$Message.error(this.message)
          this.payStatus = 0
        }
      }).catch(error=>{
        if(error != 'token invalid'){
          this.$Message.error('系统异常！请稍后再试')
        }
        this.payStatus = 0
        this.message = '系统异常！请稍后再试'
        this.loading =false
      })
    },
    // 返利套餐
    goPayProfit(param){
      delete param.type
      delete param.isProfit
      // if(param.packageId){
      //   delete param.packageId
      // }
      miniModel.openProfit(param).then(response=>{
        this.loading = false
        let res = response.data
        console.log('res',res)
        if(res.code == 200){
          if(res.data){
            this.payStatus = 1
            this.orderId = res.data.orderNumber
            this.packageRecordId = res.data.id
            this.money = res.data.orderPrice
            this.totalCount = res.data.endTime
            this.$store.dispatch('official/changePackageRecordId', res.data.packageProfitRecordId)
            this.selectPay(1)
            this.initInterval()
            // this.getAliPayHtml()
          }else{
            this.message = res.message?res.message:'系统异常！请稍后再试'
            this.$Message.error(this.message)
            this.payStatus = 0
          }
        }else{
          this.message = res.message?res.message:'系统异常！请稍后再试'
          this.$Message.error(this.message)
          this.payStatus = 0
        }
      }).catch(error=>{
        this.loading =false
        if(error != 'token invalid'){
          this.$Message.error('系统异常！请稍后再试')
        }
        this.payStatus = 0
        this.message = '系统异常！请稍后再试'
      })
    },
    // 获取支付二维码
    getAliPayHtml() {
      let param = this.copy(this.$route.query)
      let type = param.type
      let isProfit = Boolean(parseInt(param.isProfit))
      let condition = ((type == 2 && isProfit))
      payModel.getAlipayHtml({
        money:this.money,
        recordId:this.packageRecordId,
        type:condition?0:(isProfit)?1:0
      }).then(response=>{
        if(response.data){
          let result = response.data
          if(result.code_url){
            // this.qrcode(result.code_url)
            this.intervalQuery(this.packageRecordId); // 定时查询支付结果
          }
        }else{
          this.$message.error('调取支付宝页面失败')
        }
      }).catch(error=>{
        console.log(error)
        if(error != 'token invalid'){
          this.$message.error('系统异常请稍后再试！')
        }
      })
    },
    initInterval(){
      // 倒计时15分钟
      let totalCount = 15*60
      let that = this
      this.interval = setInterval(function () {
        totalCount --
        let tempMin = Math.floor(totalCount/60)
        that.minute = tempMin
        let tempSecond = totalCount-(tempMin*60)
        that.second = Math.floor(tempSecond)
        if(that.minute == 0 && that.second == 0) {
          console.log('倒计时为0')
        }
        // if(totalCount == 0){
        //   clearInterval(that.interval)
        //   that.$router.push('/pc/official/dialog')
        // }
      },1000)
    },
    copy(obj){
      //深拷贝
      let objCopy = {};
      for(let key in obj){
        objCopy[key] = obj[key];
      }
      return objCopy;
    },
    changePayMethod(payMethod){
      this.payMethod = payMethod;
    },
    //生成二维码
    qrcode(url){
      // 清空之前的二维码
      document.getElementById("qrcode").innerHTML = "";
      var maxWidth = this.$refs.qrcode.clientWidth
      let qrcode = new QRCode(this.$refs.qrcode, {
        text: url,
        width: maxWidth,
        height: maxWidth,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    },
    intervalQuery(recordId) {
      if(this.timer){
        return
      }
      let param = this.copy(this.$route.query)
      let isProfitType
      if(param.isProfitType){
        isProfitType = param.isProfitType
      }else {
        isProfitType = 0
      }
      let type = param.type
      let isProfit = Boolean(parseInt(param.isProfit))
      let condition = ((type == 2 && isProfit))
      var that = this
      this.timer = setInterval(function () {
        console.log('AASS')
        miniModel.getPayStatus({
          // type: condition?0:(isProfit)?1:0,
          // recordId:recordId
          id:that.packageRecordId
        }).then(response=>{
          console.log('response',response)
          if(response.data.data.is_success){
            clearInterval(this.timer)
            console.log('type',type)
            var profitSnapShotId = response.data.data.profitSnapShotId
            var snapshotId = response.data.data.snapShotId
            var transactionId = response.data.data.transactionId
            console.log('transactionId',transactionId)
            var pitIdZfb = response.data.data.pitId
            if(snapshotId > 0) {
              setSnapshotId(snapshotId)
            }else if(profitSnapShotId > 0){
              snapshotId = getSnaphotId()
            }
            setHasPackage(true)
            // that.$store.dispatch('official/changeIsShowSlide', true)
            // that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 0)
            // 快照id
            // if(type === 4){
            //
            // }else {
            //   that.$router.back()
            // }
            console.log('isProfitType',isProfitType)
            if(type == 1 || type == 3 || isProfitType == 1){
              console.log('AASS==1')
              that.$router.push({
                path: '/pc/zfbMiniProgram/home',
                query: {}
              })
            }
            if(type == 4 && isProfitType == 0){
              console.log('AASS==2')
              that.$router.push({
                path: '/pc/zfbMiniProgram/auto',
                query: { platformUuid: getPlatformUuid(),snapshotId:snapshotId,transactionId:transactionId,isPay:true,pitIdZfb:pitIdZfb }
              })
            }
          }
        }).catch(error=>{
          console.log(error)
        })
      },2000)
    },
    // 选择支付方式
    selectPay(index){
      this.isPayType = index
      if(index == 1){
        this.isPayTitle = '支付宝'
        this.isPayText = '打开支付宝[扫一扫]'
        this.isPayImg = 'https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png'
        this.isPayBgColor = '#00AAEE'
        let type = 0
        this.payChange(type)
      }
      if(index == 2){
        this.isPayTitle = '微信支付'
        this.isPayText = '用微信扫一扫付款'
        this.isPayImg = 'https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png'
        this.isPayBgColor = '#0EC060'
        let type = 2
        this.payChange(type)
      }
      if(index == 3){
        this.isPayTitle = '银联支付'
        this.isPayText = '请使用云闪付或各大银行app扫码'
        this.isPayImg = 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/images/tixian_icon_bank%402x.png'
        this.isPayBgColor = '#0067B7'
        let type = 0
        this.payChange(type)
      }
    },
    // 获取支付二维码
    payChange(index){
      this.payType = index
      let param = this.copy(this.$route.query)
      let type = param.type
      let isProfit = Boolean(parseInt(param.isProfit))
      let condition = ((type == 2 && isProfit))
      let params = {
        id:this.packageRecordId,
        type:condition?0:(isProfit)?1:0,
        // paymentMethod:index
        payType:index
      }
      miniModel.getPayCode(params).then(res=>{
        if(res.data.code == 200){
          let base64 = res.data.data
          if(index == 2 || index == 0){
            this.qrcode(res.data.data)
          }
          // 如果首信易为空就使用之前银联的
          if(res.data.data){
            this.base64 = base64
          }else {
            if(!this.isQrcode){
              this.qrcode(res.data.data)
              this.isQrcode = true
            }
          }
          this.intervalQuery(this.packageRecordId);
        }else {
          this.$message.error(res.data.message)
        }
      }).finally(()=>{
        this.loadingPay = false
      })
    },
  }
}
</script>

<style scoped>
/*start 步奏条样式*/
>>>.el-step__title.is-success,>>>.el-step__title.is-process{
  font-size: 14px;
  color: #FF8622;
  font-family: Alibaba-PuHuiTi-R;
  font-weight: normal;
}
>>>.el-step__title.is-wait{
  color: #C1C1C1;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R;
}

>>>.el-step__head.is-success{
  color: #FF8622;
  border-color: #FF8622;
  font-family: Alibaba-PuHuiTi-R;
}
>>>.el-step__head.is-process{
  color: #FF8622;
  border-color: #FF8622;
  font-family: Alibaba-PuHuiTi-R;
  font-weight: normal;
}
>>>.el-step__head.is-success .el-step__icon.is-text{
  background: #FF8622;
  color: #fff;
}
>>>.el-step__head.is-process .el-step__icon.is-text{
  background: #FF8622;
  color: #fff;
}
/*end 步奏条样式*/
.body-content{
  height:100vh;
}
.content-wrapper{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: #F5F5FA;
  height: 100%;
  /*height: calc(100vh - 80px);*/
}
.content-wrapper .main-content{
  margin-top: 20px;
  max-width: 1200px;
  font-family: Alibaba-PuHuiTi-R;
  background: #fff;
  /*width: 62.5vw;*/
  width: 100%;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.06);
  border-radius: 8px;
  padding:40px;
  min-height: 638px;
  display: flex;
  flex-flow:column nowrap;
}
.title{
  display: flex;
  align-items: center;
}
.title .main-title{
  flex: 1;
  font-size: 32px;
  color: #222222;
  margin-top: -10px;
}
.title .step-bar{
  flex: 1;
}
.tip-box{
  background: #FAFAFA;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding:40px 0;
  margin-top: 40px;
}
.tip-box .tip-icon{
  color: #FF4F76 ;
  font-size: 48px;
}
.tip-box .tip-icon-success{
  font-size: 48px;
  color: #3D9EFC ;
}
.tip-box .main-tip-box{
  margin-left: 12px;
}
.tip-box .main-tip-box .tip-title{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
}
.tip-box .main-tip-box .tip-sub-title{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #666666;
  margin-top: 10px;
}
.tip-box .main-tip-box .tip-sub-title .pink-class{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #FF4F76;
  line-height: 20px;
}
.pay-way{
  margin-top: 40px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.pay-way .pay-way-tip{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 20px;
  color: #222222;
  height: 27px;
  line-height: 27px;
  margin-right: 20px;

}
.pay-way .pay-way-list{
  display: flex;
}
.pay-way .alipay-icon{
  margin-left: 20px;
  padding: 10px 40px;
  border: 1px solid #E8E8E8;
  border-radius: 2px;
  position: relative;
  background: #FFFFFF;
}
.pay-way .alipay-icon.active{
  border: 1px solid #FF8622;
}
.pay-way .alipay-icon .pay-way-text{
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #3F3A39;
  letter-spacing: 0;
  margin-left: 5px;
}
.pay-way .triangle{
  color: #fff;
  width: 0;
  height: 0;
  border: 14px solid #FF8622;
  border-left: 14px solid transparent;
  border-top: 14px solid transparent;
  position: absolute;
  bottom: 0;
  right: 0;
}
.pay-way .triangle .triangle-icon{
  position: relative;
  top:-3px;
  font-size: 15px;
  right:1px;
}
.pay-money{
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.pay-money .pay-money-tip{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 20px;
  color: #222222;
  height: 27px;
  line-height: 27px;
}
.pay-money .pay-money-text{
  margin-left: 20px;
  font-family: Alibaba-PuHuiTi-M;
  font-size: 32px;
  color: #FF4F76;
  height: 44px;
  line-height: 44px;
}
.pay-money .pay-money-text .pay-icon{
  font-size: 18px;
}
.pay-qr-code{
  width: 220px;
  margin-left: 90px;
  margin-top: 30px;
  position: relative;
}
.pay-qr-code .bg-img{
  width: 220px;
}
.pay-qr-code .qrcode-img{
  background: #FAFAFA;
  padding: 5px;
  border: 0;
  width: 130px;
  height: 130px;
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%);	/* IE 9 */
  -moz-transform: translateX(-50%);	/* Firefox */
  -webkit-transform: translateX(-50%);/* Safari 和 Chrome */
  -o-transform: translateX(-50%); 	/* Opera */
}
.pay-qr-code .qrcode-img div{
  width: 120px;
}
.pay-qrcode-img{
  margin-left: 20px;
  position: relative;
  width: 240px;
}
.pay-qrcode-img .bg-img{
  width: 240px;
}
.pay-qrcode-img .qrcode-img{
  text-align: center;
  padding: 5px;
  background: #F5F5FA;
  width: 120px;
  position: absolute;
  top: 148px;
  left: 50%;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%);	/* IE 9 */
  -moz-transform: translateX(-50%);	/* Firefox */
  -webkit-transform: translateX(-50%);/* Safari 和 Chrome */
  -o-transform: translateX(-50%); 	/* Opera */
}
.pay-qrcode-img .qrcode-img div{
  width: 110px;
}
.pay-btn-wrap{
  display: flex;
  flex: 1;
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
}
.pay-btn-wrap .pay-info-wrap{
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 46px;
  right: 0;
  align-items: center;
}
.pay-btn-wrap .pay-info-wrap .pay-money-text{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 20px;
  color: #222222;
  line-height: 27px;
}
.pay-btn-wrap .pay-info-wrap .pay-money{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 32px;
  color: #FF4F76;
  line-height: 44px;
  margin-left: 2px;
}
.pay-btn-wrap .pay-info-wrap .pay-money .pay-icon{
  font-size: 8px;
}
.pay-btn-wrap .pay-btn{
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  right: 0;
}

.pay-btn-wrap .pay-btn span{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 205px;
  background: #FF8622;
  border-radius: 2px;
  color: #fff;
  height: 36px;
}
</style>
<style lang="less" scoped>
.pay{
  display: flex;
  align-items: center;
  .pay-item{
    width: 160px;
    height: 48px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #E8E8E8;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;
    img{
      width: 28px;
      height: 28px;
    }
    .pay-item-text{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3F3A39;
      line-height: 25px;
      margin-left: 5px;
    }
  }
  .pay-item-active{
    border-radius: 2px;
    border: 1px solid #FF8622;
  }
}
.pay-qrcode{
  width: 220px;
  height: 300px;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
  margin-top: 30px;
  .qrcode-top{
    height: 60px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 28px;
      height: 28px;
    }
    .qrcode-top-text{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 25px;
      margin-left: 8px;
    }
  }
  .qrcode-center{
    width: 220px;
    height: 240px;
    background: #0EC060;
    padding-top: 40px;
    .qrcode-center-img{
      width: 120px;
      height: 120px;
      background: #FAFAFA;
      margin: auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .qrcode-center-text{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/pay/index.vue